import { FTU_WIZARD_STEPS } from '../constants';
import { BrandedReturnsProvider } from '../context/branded-returns-context';
import { MarketplaceProvider } from '../context/marketplace-context';
import { AdvancedOptionsStep } from '../steps/advanced-options-step';
import { CarrierStep } from '../steps/carrier-step';
import { DiscountedRatesStep } from '../steps/discounted-rates-step';
import { InventorySetupStep } from '../steps/inventory-setup-step';
import { OrdersStep } from '../steps/orders-step';
import { PhoneNumberStep } from '../steps/phone-number-step';
import { ReturnsStep } from '../steps/returns-step';
import { ShipFromManager } from '../steps/ship-from-step/ship-from-manager';

export const StepRenderer = ({
  currentStepKey,
  handleInsuranceSelectionChange,
  handleOrdersCsvFileChange,
  handleOrdersImportReadyChange,
  handleManualOrderAdded,
  handleShipFromValidationChange,
  handleShipFromSaveFunctionReady,
  handleShipFromSuccess,
  handleRefundAssistSaveReady,
  handleRefundAssistToggleChange,
  handlePhoneNumberValidationChange,
  handlePhoneNumberSaveFunctionReady,
  selectedStoreGuid,
}) => {
  switch (currentStepKey) {
    case FTU_WIZARD_STEPS.ORDERS:
      return (
        <MarketplaceProvider>
          <OrdersStep
            onCsvFileChange={handleOrdersCsvFileChange}
            onImportReadyChange={handleOrdersImportReadyChange}
            onManualOrderAdded={handleManualOrderAdded}
          />
        </MarketplaceProvider>
      );
    case FTU_WIZARD_STEPS.SHIP_FROM:
      return (
        <ShipFromManager
          onFormValidationChange={handleShipFromValidationChange}
          onSaveFunctionReady={handleShipFromSaveFunctionReady}
          onSuccess={handleShipFromSuccess}
        />
      );
    case FTU_WIZARD_STEPS.CARRIER:
      return (
        <CarrierStep onRefundAssistSaveReady={handleRefundAssistSaveReady} onRefundAssistToggleChange={handleRefundAssistToggleChange} />
      );
    case FTU_WIZARD_STEPS.PHONE_NUMBER:
      return (
        <PhoneNumberStep onSaveFunctionReady={handlePhoneNumberSaveFunctionReady} onValidationChange={handlePhoneNumberValidationChange} />
      );
    case FTU_WIZARD_STEPS.DISCOUNTED_RATES:
      return <DiscountedRatesStep onInsuranceSelectionChange={handleInsuranceSelectionChange} />;
    case FTU_WIZARD_STEPS.ADVANCED_OPTIONS:
      return <AdvancedOptionsStep />;
    case FTU_WIZARD_STEPS.INVENTORY_SETUP:
      return <InventorySetupStep />;
    case FTU_WIZARD_STEPS.RETURNS:
      return (
        <BrandedReturnsProvider storeGuid={selectedStoreGuid}>
          <ReturnsStep />
        </BrandedReturnsProvider>
      );
    default:
      return null;
  }
};
